import React from "react";
import {
  Address,
  Anchor,
  Container,
  H2,
  H5,
  Paragraph,
  Section,
} from "../../Styles/Global.Styled";
import PhoneIcon from "../../Icons/PhoneIcon";
import EnvelopeIcon from "../../Icons/EnvelopeIcon";
import { locations } from "../../helpers/data";
import { css } from "styled-components";

const cntStyle = css`
  flex-direction: column;
  gap: 4vh;
  width: 50%;
`;
const widthStyle = css`
  width: 100%;
`;
const gapStyle = css`
  gap: 1vh;
`;
const gap2Style = css`
  gap: 2vh;
  flex-direction: column;
  /* border: 2px solid red; */
`;
const flexDircStyle = css`
  /* border: 2px solid red; */
  flex-direction: column;
`;
const h5Style = css`
  align-items: center;
  gap: 0.5vh;
`;
const iconSize = { height: "3vh", width: "3vh" };

const ContactSection = () => {
  return (
    <Container $baseStyle={cntStyle} $mStyle={widthStyle}>
      <Section $baseStyle={gapStyle}>
        <H2>Get in Touch</H2>
        <Paragraph>
          Have a question or inquiry? We'd love to hear from you! Feel free to
          <br />
          reach out to us using the contact details immediately.
        </Paragraph>
      </Section>
      <Section $baseStyle={gapStyle}>
        <H2>Our Contact details</H2>
        <Anchor>
          <PhoneIcon style={iconSize} />
          +31 6 8951 28 19
        </Anchor>
        <Anchor>
          <EnvelopeIcon style={iconSize} />
          cs@freshflowersupply.com
        </Anchor>
      </Section>
      <Section $baseStyle={gapStyle}>
        <H2>Our Locations:</H2>
        <Container $baseStyle={gap2Style}>
          {locations.map((loc, index) => (
            <Container key={index} $baseStyle={flexDircStyle}>
              <H5 $baseStyle={h5Style}>
                {loc.flag}
                {loc.type}
              </H5>
              <Address>{loc.address}</Address>
            </Container>
          ))}
        </Container>
      </Section>
    </Container>
  );
};

export default ContactSection;
